import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-900 text-background-200">
      <div className="w-full px-4 py-12 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-white">
                <i className="ri-movie-2-fill text-xl" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-extrabold text-background-50">
                黄色<span className="text-accent-400">在线</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              黄色在线是一个综合影视资源与资讯展示平台，聚合电影、电视剧、综艺等热门作品，
              并提供最新影视行业动态。所有内容均为演示数据，不提供影片播放与下载服务。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">影视分类</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/category/movie" className="transition-colors hover:text-accent-300">
                  电影
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="transition-colors hover:text-accent-300">
                  电视剧
                </Link>
              </li>
              <li>
                <Link to="/category/variety" className="transition-colors hover:text-accent-300">
                  综艺
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">资讯与更多</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/news/industry" className="transition-colors hover:text-accent-300">
                  行业动态
                </Link>
              </li>
              <li>
                <Link to="/news/review" className="transition-colors hover:text-accent-300">
                  影视评论
                </Link>
              </li>
              <li>
                <Link to="/search" className="transition-colors hover:text-accent-300">
                  全站搜索
                </Link>
              </li>
              <li>
                <Link to="/about" className="transition-colors hover:text-accent-300">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-primary-700 pt-6 text-sm text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 黄色在线 · 演示站点，仅用于展示与学习</p>
          <ul className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <li className="transition-colors hover:text-accent-300">联系我们：hello@huangse-online.demo</li>
            <li className="hidden sm:block opacity-60">|</li>
            <li className="transition-colors hover:text-accent-300">友情链接：光影资料馆</li>
          </ul>
        </div>
      </div>
    </footer>
  );
}